import React, {Fragment, useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import DateFnsUtils from "@date-io/date-fns"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

// Material-UI Lab
import Autocomplete from '@material-ui/lab/Autocomplete'

// Material-UI
import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Style
import {advancedSearchFormStyle} from '../../styles/jss/components/fileManager/advancedSearchFormStyle'

// Fetch Data
import {getAdvSearchCompanyList} from '../../dataSource/fileManager'


const useStyles = makeStyles(theme => advancedSearchFormStyle(theme))

const AdvancedSearchForm = () => {
	const classes = useStyles()
	const dispatch = useDispatch()

	// Redux Data
	const advancedSearchRedux = useSelector(state => state.advancedSearchRedux)

	// Define State
	const [companyListResult, setCompanyListResult] = useState([])

	const [searchKeyWord, setSearchKeyWord] = useState({
		operator: "and",   // or, and
		doc_code: "",
		filename: "",
		file_subject: "",
		company_seq: "",
		inout: "",
		is_confidential: "",
		ref_no: "",
		content: "",
		remark: "",
		date_of_document_start: null,
		date_of_document_end: null,
		createdate_start: null,
		createdate_end: null,
		modifydate_start: null,
		modifydate_end: null
	})

	dispatch({
		type: "ADV_SEARCH_KEYWORD_ADD",
		data: searchKeyWord
	})


	const handleTextChange = event => {
		const {name, value} = event.target
		const newKeyWord = {...searchKeyWord}
		newKeyWord[name] = value

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleCompanySelectChange = (event, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.company_seq = value ? value.company_seq : 99999
		
		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleSelectChange = event => {
		const {name, value} = event.target
		const newKeyWord = {...searchKeyWord}
		newKeyWord[name] = value

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}
	
	const handleDateOfDocumentStartChange = (date, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.date_of_document_start = date

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleDateOfDocumentEndChange = (date, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.date_of_document_end = date

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleCreateDateStartChange = (date, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.createdate_start = date

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleCreateDateEndChange = (date, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.createdate_end = date

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleModifyDateStartChange = (date, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.modifydate_start = date

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}

	const handleModifyDateEndChange = (date, value) => {
		const newKeyWord = {...searchKeyWord}
		newKeyWord.modifydate_end = date

		setSearchKeyWord(newKeyWord)
		dispatch({
			type: "ADV_SEARCH_KEYWORD_ADD",
			data: newKeyWord
		})
	}


	useEffect(() => {
		getAdvSearchCompanyList().then(res => {
			setCompanyListResult(res.data.data)
		})
		.catch(error => {
			console.error("Get Advanced Search Company List Error:")
			console.error(error)
		})
	}, [])



	return (
		// console.log("Advanced Search Company List | Variable: companyListResult (AdvancedSearchForm.js)"),
		// console.log(companyListResult),

		// console.log("Advanced Search searchKeyWord | Variable: searchKeyWord (AdvancedSearchForm.js)"),
		// console.log(searchKeyWord),

		// console.log("---------------------------------------------------------------------------------"),

		
		<Fragment>
			<form className={classes.root} noValidate autoComplete="off">
				<TextField 
					id="doc_code" 
					name="doc_code" 
					label="Doc. Code" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchKeyWord.doc_code || ""} 
					onChange={handleTextChange} 
				/>

				<TextField 
					id="filename" 
					name="filename" 
					label="File Name" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchKeyWord.filename || ""} 
					onChange={handleTextChange} 
				/>
				
				<TextField 
					id="file_subject" 
					name="file_subject" 
					label="Subject" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchKeyWord.file_subject || ""} 
					onChange={handleTextChange} 
				/>

				<Autocomplete
					// multiple
					id="company_seq"
					name="company_seq"
					options={companyListResult}
					getOptionLabel={option => option.company_name}
					onChange={(event, value) => {
						handleCompanySelectChange(event, value)
					}}

					renderInput={params => (
						<TextField
							{...params}
							// required
							// name="company_seq"
							variant="outlined"
							label="Organization"
							size="small"
							InputLabelProps={{
								shrink: true,
							}}
						/>
					)}
				/>

				<TextField
					select
					id="inout"
					name="inout"
					label="In/Out"
					value={searchKeyWord.inout || ""}
					fullWidth={true}
					size="small"
					variant="outlined"
					onChange={handleSelectChange}
				>
					<MenuItem key={"init"} value={""} selected><em>None</em></MenuItem>
					<MenuItem key={"NA"} value={"NA"}>NA</MenuItem>
					<MenuItem key={"in"} value={"in"}>IN</MenuItem>
					<MenuItem key={"out"} value={"out"}>OUT</MenuItem>
				</TextField>

				<TextField
					select
					id="is_confidential"
					name="is_confidential"
					label="Confidential"
					value={searchKeyWord.is_confidential || ""}
					fullWidth={true}
					size="small"
					variant="outlined"
					onChange={handleSelectChange}
				>
					<MenuItem key={"init"} value={""} selected><em>None</em></MenuItem>
					<MenuItem key={"Y"} value={true}>YES</MenuItem>
					<MenuItem key={"N"} value={false}>NO</MenuItem>
				</TextField>

				<TextField 
					id="ref_no" 
					name="ref_no" 
					label="Reference Number" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchKeyWord.ref_no || ""} 
					onChange={handleTextChange} 
				/>

				<TextField
					id="content" 
					name="content" 
					label="Content" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchKeyWord.content || ""}
					onChange={handleTextChange}
				/>

				<TextField 
					id="remark" 
					name="remark" 
					label="Remark" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchKeyWord.remark || ""} 
					onChange={handleTextChange} 
				/>

				<MuiPickersUtilsProvider utils={DateFnsUtils} >

					<Grid container justify="space-between">
						<KeyboardDatePicker
							id="date_of_document_start"
							name="date_of_document_start"
							label="Date of Document (From)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							value={searchKeyWord.date_of_document_start || null}
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							onChange={handleDateOfDocumentStartChange}
							className={classes.datePickerField}
						/>
					
						<KeyboardDatePicker
							id="date_of_document_end"
							name="date_of_document_end"
							label="Date of Document (To)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							value={searchKeyWord.date_of_document_end || null}
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							onChange={handleDateOfDocumentEndChange}
							className={classes.datePickerField}
						/>
					</Grid>

					<Grid container justify="space-between">
						<KeyboardDatePicker
							id="createdate_start"
							name="createdate_start"
							label="Create Date (From)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							value={searchKeyWord.createdate_start || null}
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							onChange={handleCreateDateStartChange}
							className={classes.datePickerField}
						/>
					
						<KeyboardDatePicker
							id="createdate_end"
							name="createdate_end"
							label="Create Date (To)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							value={searchKeyWord.createdate_end || null}
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							onChange={handleCreateDateEndChange}
							className={classes.datePickerField}
						/>
					</Grid>

					<Grid container justify="space-between">
						<KeyboardDatePicker
							id="modifydate_start"
							name="modifydate_start"
							label="Modified Date (From)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							value={searchKeyWord.modifydate_start || null}
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							onChange={handleModifyDateStartChange}
							className={classes.datePickerField}
						/>

						<KeyboardDatePicker
							id="modifydate_end"
							name="modifydate_end"
							label="Modified Date (To)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							value={searchKeyWord.modifydate_end || null}
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							onChange={handleModifyDateEndChange}
							className={classes.datePickerField}
						/>
					</Grid>
				</MuiPickersUtilsProvider>
			</form>
		</Fragment>
	)
}


export default AdvancedSearchForm